import PropTypes from 'prop-types';
import { extendObservable } from 'mobx';
import BoolStore from '../helpers/BoolStore';

export default class OverviewStore {
    static PropType = PropTypes.shape({
        step1: BoolStore.PropTypes.isRequired,
        step2: BoolStore.PropTypes.isRequired,
        step3: BoolStore.PropTypes.isRequired,
        step4: BoolStore.PropTypes.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class OverviewStore */{
            step1: new BoolStore(true),
            step2: new BoolStore(true),
            step3: new BoolStore(true),
            step4: new BoolStore(true),
        }, data);
    }
}
